import React, { useState, useEffect } from "react";
import { useAuth } from "../../contexts/AuthContext";
import RequestsTable from "../RequestsTable/RequestsTable";
import SummarySection from "../SummarySection/SummarySection";
import EventDetails from "../EventDetails/EventDetails";
import { useSortableTable } from "../../hooks/useSortableTable";
import Button from "../UI/Button";
import "./Dashboard.css";

const Dashboard = () => {
  const { user, logout } = useAuth();
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [summaryData, setSummaryData] = useState([]);
  const [isLoad, setIsLoad] = useState(false);
  const [fundRequests, setFundRequests] = useState([]);
  const [requestIdInput, setRequestIdInput] = useState("");
  const [isDetailsByEventId, setIsDetailsByEventId] = useState(true);

  const {
    sortedData: sortedRequests,
    handleSort,
    getSortIndicator,
  } = useSortableTable(fundRequests, "id", "desc");

  const handleViewDetails = async (eventId) => {
    sessionStorage.setItem(
      "fundRequestsScrollPosition",
      window.scrollY.toString()
    );
    setSelectedRequest(eventId);
    setIsDetailsByEventId(true);
  };

  const handleBackToTable = () => {
    setSelectedRequest(null);
  };

  const handleRequestsLoaded = (data) => {
    setFundRequests(data.requests);
    setSummaryData(data.summary || []);
    setIsLoad(true);
  };

  const handleRequestIdSearch = () => {
    if (requestIdInput.trim()) {
      const requestId = requestIdInput.trim();
      setSelectedRequest(requestId);
      setIsDetailsByEventId(false);
      setRequestIdInput("");
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleRequestIdSearch();
    }
  };

  useEffect(() => {
    if (!selectedRequest) {
      const savedScrollPosition = sessionStorage.getItem(
        "fundRequestsScrollPosition"
      );
      if (savedScrollPosition) {
        setTimeout(() => {
          window.scrollTo(0, parseInt(savedScrollPosition));
          sessionStorage.removeItem("fundRequestsScrollPosition");
        }, 0);
      }
    }
  }, [selectedRequest]);

  if (selectedRequest) {
    return (
      <EventDetails eventId={selectedRequest} isDetailsByEventId={isDetailsByEventId} onBack={handleBackToTable} />
    );
  }

  return (
    <div className="dashboard">
      <header className="dashboard__header">
        <div className="dashboard__header-content">
          <h1 className="dashboard__title">Fund Request Management System</h1>
          <div className="dashboard__user-section">
            <span className="dashboard__welcome">Hello, {user?.username}</span>
            <Button
              variant="outline"
              size="small"
              onClick={logout}
              className="dashboard__logout-btn"
            >
              Sign Out
            </Button>
          </div>
        </div>
      </header>

      <main className="dashboard__main">
        <div className="request-id-search">
          <div className="request-id-search__container">
            <label
              htmlFor="requestIdInput"
              className="request-id-search__label"
            >
              Search by Request ID:
            </label>
            <div className="request-id-search__input-group">
              <input
                id="requestIdInput"
                type="text"
                value={requestIdInput}
                onChange={(e) => setRequestIdInput(e.target.value)}
                onKeyPress={handleKeyPress}
                placeholder="Enter Request ID"
                className="request-id-search__input"
              />
              <Button
                onClick={handleRequestIdSearch}
                className="request-id-search__button"
                disabled={!requestIdInput.trim()}
              >
                Submit
              </Button>
            </div>
          </div>
        </div>
        <SummarySection summaryData={summaryData} />
        <RequestsTable
          sortedRequests={sortedRequests}
          handleSort={handleSort}
          getSortIndicator={getSortIndicator}
          onViewDetails={handleViewDetails}
          onRequestsLoaded={handleRequestsLoaded}
          isLoad={isLoad}
        />
      </main>
    </div>
  );
};

export default Dashboard;
